import { CloseOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { Button, Col, Row, Typography } from 'antd';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { IPristupy, ISeznamNotifikaci } from 'services/profily';

interface ISeznamAkciNotification {
    profily: IPristupy[];
}

// Typ akce - zelena: doporucena, cervena: nutna, zluta: zatim nevime :D
const actionNotificationTypeMap = [
    {
        typ: 'ZELENE',
        class: 'dash-not-green',
        icon: <InfoCircleOutlined className="dash-not-green-icon" />
    },
    {
        typ: 'ZLUTE',
        class: 'dash-not-yellow',
        icon: <WarningOutlined className="dash-not-yellow-icon" />
    },
    {
        typ: 'CERVENE',
        class: 'dash-not-red',
        icon: <WarningOutlined className="dash-not-red-icon" />
    }
];
// Mapa notifikaci podle daneho typu akce
const actionNotificationMap = (notifikace: ISeznamNotifikaci) => {
    return actionNotificationTypeMap.map((x, index) => {
        if (x.typ === notifikace.typ) {
            return (
                <Row className={x.class} key={index}>
                    <Col xs={24} xl={2}>
                        {x.icon}
                    </Col>
                    <Col
                        xs={24}
                        xl={12}
                        style={{
                            marginTop: '0.4em'
                        }}
                    >
                        <Typography.Text className="dash-not-type-title">{notifikace.typText}</Typography.Text>
                        <Typography.Paragraph className="dash-not-type-comment">{notifikace.text}</Typography.Paragraph>
                    </Col>
                    <Col xs={24} xl={10}>
                        <Row
                            gutter={16}
                            justify="end"
                            style={{
                                marginTop: '0.75em',
                                marginBottom: '0.75em'
                            }}
                        >
                            <Button type="primary" size="large" ghost={true}>
                                <TranslateText>PREJIT</TranslateText>
                            </Button>
                            <Button
                                type="link"
                                style={{
                                    marginTop: '0.1em',
                                    marginBottom: '0.1em'
                                }}
                                ghost={true}
                            >
                                <CloseOutlined />
                            </Button>
                        </Row>
                    </Col>
                </Row>
            );
        }
    });
};

const DashboardNotificationType: React.FC<ISeznamAkciNotification> = ({ profily }) => {
    // Pro kazdy typ akce se vypisuje jina notifikace
    return (
        <Row
            style={{
                marginTop: '10px'
            }}
            gutter={16}
            justify="start"
        >
            {profily.map(
                (pristupy, index) =>
                    (pristupy?.seznotifikaci?.length || 0) > 0 && (
                        <Col xs={24} xl={24} key={index}>
                            {pristupy.seznotifikaci?.map(actionNotificationMap)}
                        </Col>
                    )
            )}
        </Row>
    );
};

export default DashboardNotificationType;
